import {
  createContext,
  type Dispatch,
  type FC,
  type MutableRefObject,
  type PropsWithChildren,
  type SetStateAction,
  useState,
} from 'react';

interface HeaderAnimationContext {
  cashBalanceRef: MutableRefObject<HTMLDivElement | null> | null;
  setCashBalanceRef: Dispatch<
    SetStateAction<MutableRefObject<HTMLDivElement | null> | null>
  >;
  cashBalanceScale: boolean;
  setCashBalanceScale: Dispatch<SetStateAction<boolean>>;

  tgemBalanceRef: MutableRefObject<HTMLDivElement | null> | null;
  setTgemBalanceRef: Dispatch<
    SetStateAction<MutableRefObject<HTMLDivElement | null> | null>
  >;
  tgemBalanceScale: boolean;
  setTgemBalanceScale: Dispatch<SetStateAction<boolean>>;
}

const HeaderAnimationContext = createContext({} as HeaderAnimationContext);

const HeaderAnimationProvider: FC<PropsWithChildren> = ({ children }) => {
  const [cashBalanceScale, setCashBalanceScale] = useState(false);
  const [cashBalanceRef, setCashBalanceRef] =
    useState<MutableRefObject<HTMLDivElement | null> | null>(null);

  const [tgemBalanceScale, setTgemBalanceScale] = useState(false);
  const [tgemBalanceRef, setTgemBalanceRef] =
    useState<MutableRefObject<HTMLDivElement | null> | null>(null);

  return (
    <HeaderAnimationContext.Provider
      value={{
        cashBalanceScale,
        setCashBalanceScale,
        cashBalanceRef,
        setCashBalanceRef,
        setTgemBalanceRef,
        setTgemBalanceScale,
        tgemBalanceRef,
        tgemBalanceScale,
      }}
    >
      {children}
    </HeaderAnimationContext.Provider>
  );
};

export { HeaderAnimationContext, HeaderAnimationProvider };
